var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1394.1 1396"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1394.1 532.3-501.3-45.4L697 0 501.3 486.9 0 532.1l380.2 347.3-113.9 516.5L697 1122.2l430.8 273.8-113.9-516.4z"
  })));
};
export default SvgStar;